'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Switches on a given prop. Returns the value or function for a given prop value.
 * Otherwise returns `defaultValue`
 * @param defaultValue *deprecated*
 * @example
 * import styled, { css } from 'styled-components'
 * import { switchProp, prop } from 'styled-tools'
 *
 * const Button = styled.button`
 *  font-size: ${switchProp(prop('size', 'medium'), {
 *    small: prop('theme.sizes.sm', '12px'),
 *    medium: prop('theme.sizes.md', '16px'),
 *    large: prop('theme.sizes.lg', '20px'),
 *  }};
 *  ${switchProp('theme.kind', {
 *    light: css`
 *      color: LightBlue;
 *    `,
 *    dark: css`
 *      color: DarkBlue;
 *    `,
 *  })}
 * `
 *
 * <Button size="large" theme={{ kind: 'light' }} />
 */
var switchProp = function switchProp(needle, switches, defaultValue) {
  if (typeof defaultValue !== 'undefined') {
    console.warn(['[styled-tools] Passing `defaultValue` as third argument to `switchProp` is deprecated.', 'Please use `switchProp(prop(path, defaultValue), { ... })` instead.', 'See https://github.com/diegohaz/styled-tools#switchprop'].join(' '));
  }
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var value = typeof needle === 'function' ? needle(props) : (0, _get2.default)(props, needle);
    return (0, _get2.default)(switches, value, defaultValue);
  };
};
exports.default = switchProp;


//////////////////
// WEBPACK FOOTER
// ./~/styled-tools/dist/cjs/switchProp.js
// module id = 641
// module chunks = 97291517795586 114276838955818